module.exports = __webpack_public_path__ + "img/dsofile02.4a6229df.png";